// @owners { team: patients-team }
import { Body, InlineAlert } from '@alto/design-system';
import React from 'react';
import { DEFAULT_ERROR_ALERT_TITLE } from '~shared/constants';

export const CookieError = () => (
  <InlineAlert type="error">
    <Body fontFamily="semibold">{DEFAULT_ERROR_ALERT_TITLE}</Body>
    <Body>Please enable cookies and refresh page to continue.</Body>
  </InlineAlert>
);
